import { ReactNode } from 'react';

import styles from './styles/Dialog.module.css';

interface DialogProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function Dialog({ visible, onClose, title, children }: DialogProps) {
  if (!visible) return null;

  return (
    <div className={styles.dialogOverlay} onClick={onClose}>
      <div className={styles.dialog} onClick={e => e.stopPropagation()}>
        <div className={styles.dialogHeader}>
          <h3 className={styles.dialogTitle}>{title}</h3>
        </div>
        <div className={styles.dialogContent}>
          {children}
        </div>
      </div>
    </div>
  );
} 
